import React from 'react';

export default ({ data }) => (
  <div className="footer">
    <div className="container content">
      <p>&copy; Rave Reviewz 2018 - All Rights Reserved</p>
      <p>
        {/* Site by{' '}
        <a href="https://www.linkedin.com/in/j-mcmullen/" target="_blank">
          Jay McMullen
        </a> */}
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Footer.js